<template>
    <div class="adminhome" style="min-height:85vh;overflow-x: hidden;position: relative;">
        <div v-if="isLoading" style="position: absolute;left: 50%;z-index: 3;margin-left:-50px;display: inline-flex;text-align: center;top:190px;border-radius: 4px;">
            <LoadingBar />
        </div>
        <div style="display:flex">
            <div style="margin: 16px 0;display:flex">
                <a-breadcrumb style="margin-top:auto;margin-bottom:auto">
                    <a-breadcrumb-item style="font-size:30px;">Users</a-breadcrumb-item>
                    <!-- <a-breadcrumb-item>Bill</a-breadcrumb-item> -->
                </a-breadcrumb>
                <a-button style="margin-top:auto;margin-bottom:auto;margin-left:20px" type="primary">
                    <router-link to="/admin/adduser">
                    Add User
                    </router-link>
                </a-button>
            </div>
        </div>
        <div v-if="newUsers.length > 0" style="position: absolute;top: 0;width: 100%;text-align:center;display: flex;">
          <div style="margin-left: auto;margin-right: auto;color: white;cursor:pointer;border-radius: 5px;background-color: #1890ff;width:150px;padding:5px" @click="getUsers">
            {{newUsers.length}} new accounts
            <a-icon type="reload" />
          </div>
        </div>
        <export-excel  style="margin-left:5px;position:absolute;top: 0;right: 0;"
            class   = "btn-default"
            :data   = "json_data"
            :fields = "json_fields"
            :meta = "json_meta"
            type="xls"
            worksheet = "Users"
            name    = "Users Data.xls">
        
            Export Excel
        </export-excel>

        <div style="position:relative">
          <div style="position:absolute;right:0;top:-30px;display:flex;">
            <a-input-search style="width:400px;margin-right:0px;margin-left:auto" v-model="userSearchText" placeholder="" @search="onSearch">
              <a-button slot="enterButton">
                Search User
              </a-button>
            </a-input-search>
          </div>
          <div style="display:flex">
              <a-tabs
                  style="width:100%"
                  :active-key="currentTab"
                  :tab-position="'top'"
                  @change="handleTabChange"
              >
                  <a-tab-pane key="all" tab="All Users">
                      <UsersTableItem
                        :key="listState.all.pagination.pageSize"
                        :userlist="listState.all.list"
                        :columns="columns"
                        :tableCellCount="listState.all.pagination.pageSize"
                        :pagination="listState.all.pagination"
                        :loading="isLoading && currentTab === 'all'"
                        @listUpdate="() => listUpdate('all')"
                        @listFilter="status => listFilter('all', status)"
                        @listFilterCount="count => listFilterCount('all', count)"
                        @tableChange="payload => handleTableChange('all', payload)"
                      />
                  </a-tab-pane>
                  <a-tab-pane key="admin" tab="Admin" force-render>
                      <UsersTableItem
                        :key="listState.admin.pagination.pageSize"
                        :userlist="listState.admin.list"
                        :columns="columns"
                        :tableCellCount="listState.admin.pagination.pageSize"
                        :pagination="listState.admin.pagination"
                        :loading="isLoading && currentTab === 'admin'"
                        @listUpdate="() => listUpdate('admin')"
                        @listFilter="status => listFilter('admin', status)"
                        @listFilterCount="count => listFilterCount('admin', count)"
                        @tableChange="payload => handleTableChange('admin', payload)"
                      />
                  </a-tab-pane>
                  <a-tab-pane key="agent" tab="Agent">
                      <UsersTableItem
                        :key="listState.agent.pagination.pageSize"
                        :userlist="listState.agent.list"
                        :columns="columns"
                        :tableCellCount="listState.agent.pagination.pageSize"
                        :pagination="listState.agent.pagination"
                        :loading="isLoading && currentTab === 'agent'"
                        @listUpdate="() => listUpdate('agent')"
                        @listFilter="status => listFilter('agent', status)"
                        @listFilterCount="count => listFilterCount('agent', count)"
                        @tableChange="payload => handleTableChange('agent', payload)"
                      />
                  </a-tab-pane>
              </a-tabs>
          </div>
        </div>
        
        <!-- <a-table :columns="columns" :data-source="data">
            <a slot="name" slot-scope="text">{{ text }}</a>
            <span slot="customTitle"><a-icon type="smile-o" /> Name</span>
            <span slot="tags" slot-scope="tags">
            <a-tag
                v-for="tag in tags"
                :key="tag"
                :color="tag === 'loser' ? 'volcano' : tag.length > 5 ? 'geekblue' : 'green'"
            >
                {{ tag.toUpperCase() }}
            </a-tag>
            </span>
            <span slot="action" slot-scope="text, record">
            <a>Invite 一 {{ record.name }}</a>
            <a-divider type="vertical" />
            <a>Delete</a>
            <a-divider type="vertical" />
            <a class="ant-dropdown-link"> More actions <a-icon type="down" /> </a>
            </span>
        </a-table> -->
    </div>
</template>
<script>

import { api } from '../helpers/Helpers';
import UsersTableItem from './TableItems/UsersTableItem.vue'
import LoadingBar from '@/components/LoadingBar.vue';
import { bus } from '../main';
const columns = [
  // {
  //   title: 'Username',
  //   dataIndex: 'username',
  //   key: 'username',
  // },
  // {
  //   title: 'Name',
  //   dataIndex: 'name',
  //   key: 'name',
  //   sorter: true,
  // },
  {
    title: 'First Name',
    dataIndex: 'firstname',
    key: 'firstname',
    sorter: true,
  },
  {
    title: 'LastName',
    dataIndex: 'lastname',
    key: 'lastname',
    sorter: true,
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    sorter: true,
  },
  {
    title: 'Role',
    key: 'role',
    dataIndex: 'role',
    // sorter: true,
    scopedSlots: { customRender: 'tags' },
  },
  {
    title: 'State/Province',
    dataIndex: 'stateProvince',
    key: 'stateProvince',
    sorter: true,
  },
  {
    title: 'Country',
    dataIndex: 'country',
    key: 'country',
    sorter: true,
  },
  {
    title: 'Agency Name',
    dataIndex: 'agencyName',
    key: 'agencyName',
    sorter: true,
  },
  {
    title: 'Member Name',
    dataIndex: 'menberName',
    key: 'menberName',
    sorter: true,
  },
  {
    title: 'Business ID',
    dataIndex: 'businessID',
    key: 'businessID',
    sorter: true,
  },
  {
    title: 'Phone Number',
    dataIndex: 'phoneNumber',
    key: 'phoneNumber',
    sorter: true,
  },
  {
    title: 'Status',
    key: 'status',
    sorter: true,
    dataIndex: 'status',
  },
  {
    title: 'Posts',
    key: 'posts',
    dataIndex: 'posts',
  },
  {
    title: 'Created Date',
    dataIndex: 'createdDate',
    key: 'createdDate',
    sorter: true,
    scopedSlots: { customRender: 'createdDate' },
  },
  {
    title: 'Action',
    key: 'action',
    width: 200,
    scopedSlots: { customRender: 'action' },
  },
  // {
  //   title: 'Export',
  //   key: 'export',
  //   scopedSlots: { customRender: 'export' },
  // },
];

const userlist = [
  // {
  //   key: '1',
  //   username: 'John Brown',
  //   name: 32,
  //   email: 'New York No. 1 Lake Park',
  //   role: ['developer'],
  //   status: ['approved'],
  //   posts:0
  // }
];
const adminlist = [];
const agentlist = [];

const statusList = {
  0:'Pending',
  1:'Approved',
  2:'Denied'
}
const roleList = {
  1:'User',
  4:'Agent',
  2048:'Admin'
}
var newUsers = [];

const statusValueMap = {
  Default: undefined,
  Pending: 0,
  Approved: 1,
  Denied: 2,
};

const rolePermissionMap = {
  all: undefined,
  admin: 2048,
  agent: 4,
};

const createInitialState = () => ({
  list: [],
  pagination: {
    current: 1,
    pageSize: 10,
    total: 0,
  },
  statusFilter: 'Default',
  sortField: undefined,
  sortOrder: undefined,
  searchTerm: '',
});

export default {
  data() {
    return {
      columns,
      currentTab: 'all',
      listState: {
        all: createInitialState(),
        admin: createInitialState(),
        agent: createInitialState(),
      },
      userSearchText:"",
      isLoading: false,
      newUsers,

      json_fields: {
          'First Name': 'First Name',
          'Last Name': 'Last Name',
          'Email': 'Email',
          'Role': 'Role',
          'Country': 'Country',
          'Agency Name': 'Agency Name',
          'Member Name': 'Member Name',
          'Business ID': 'Business ID',
          'Phone Number': 'Phone Number',
          'State/Province': 'State/Province',
          'Status': 'Status',
          'Posts': 'Posts',
      },
      json_data: [
          {
            'First Name': 'First Name',
            'Last Name': 'Last Name',
            'Email': 'Email',
            'Role': 'Role',
            'Country': 'Country',
            'Agency Name': 'Agency Name',
            'Member Name': 'Member Name',
            'Business ID': 'Business ID',
            'Phone Number': 'Phone Number',
            'State/Province': 'State/Province',
            'Status': 'Status',
            'Posts': 'Posts',
          }
      ],
      json_meta: [
          [
              {
                  'key': 'charset',
                  'value': 'utf-8'
              }
          ]
      ],
    };
  },
  
  components: {
    UsersTableItem,
    LoadingBar
  },
  
    created: function () {
    this.newUsers = [];
		bus.$on('newagent', (data) => {
			// console.log(this.newUsers, "Users =22= = ", JSON.parse(data).email);
        const email = JSON.parse(data).email;
        const _res = this.newUsers.filter(obj => obj == email);
			// console.log(_res, "Users =_res= = ");
        if (_res.length <= 0){
          this.newUsers.push(email);

          // console.log(this.newUsers, "Users =33= = ", JSON.parse(data).email);
          this.openNotification(email);
        }
		});

      this.getUsers('all');
        
    },
    mounted(){

        // this.getUserTest();
    },
  
    methods: {
      // getUserTest:async function(){
      //   const res = await api.getUsersTest();
      //   // console.log("res=============");
      //   // console.log(res);
      //   // console.log("res=============");
      // },
        createExportData(list) {
          return list.map((cellInfo) => ({
            'First Name': cellInfo.firstname,
            'Last Name': cellInfo.lastname,
            'Email': cellInfo.email,
            'Role': cellInfo.role,
            'Country': cellInfo.country,
            'Agency Name': cellInfo.agencyName,
            'Member Name': cellInfo.menberName,
            'Business ID': cellInfo.businessID,
            'Phone Number': cellInfo.phoneNumber,
            'State/Province': cellInfo.stateProvince,
            'Status': cellInfo.status,
            'Posts': cellInfo.posts,
          }));
        },
        mapUserToCell(user, index) {
          let permission = user.permissionLevel;
          if (permission === undefined || permission === null) {
            permission = 1;
          }
          const statusValue = user.status !== undefined && user.status !== null ? user.status : 0;
          const username = user.userName || user.firstName || '';

          return {
            id: user._id,
            key: user._id || index + 1,
            username,
            firstname: user.firstName || '',
            lastname: user.lastName || '',
            email: user.email,
            role: [roleList[permission] || roleList[1]],
            status: statusList[statusValue] || statusList[0],
            posts: user.posts || 0,
            country: user.country || '',
            agencyName: user.agencyName || '',
            menberName: user.menberName || '',
            businessID: user.businessID || '',
            phoneNumber: user.phoneNumber || '',
            stateProvince: user.stateProvince || '',
            createdDate: user.createdDate,
          };
        },
        async getUsers(tabKey = this.currentTab) {
            const state = this.listState[tabKey];
            if (!state) {
              return;
            }

            this.isLoading = true;
            this.newUsers = [];

            const role = rolePermissionMap[tabKey];
            const statusValue = statusValueMap[state.statusFilter];

            const params = {
              page: state.pagination.current,
              limit: state.pagination.pageSize,
            };

            if (this.userSearchText && this.userSearchText.trim().length > 0) {
              state.searchTerm = this.userSearchText.trim();
            }

            if (state.searchTerm) {
              params.search = state.searchTerm;
            }

            if (role !== undefined) {
              params.role = role;
            }

            if (statusValue !== undefined) {
              params.status = statusValue;
            }

            if (state.sortField) {
              params.sortField = state.sortField;
              params.sortOrder = state.sortOrder || 'descend';
            }

            try {
                const res = await api.getUsersByAdmin({ params });
                const users = res && res.users ? res.users : [];
                const mappedUsers = users.map((user, index) => this.mapUserToCell(user, index));

                state.list = mappedUsers;
                state.pagination.total = res && typeof res.total === 'number' ? res.total : (users.length || 0);
                state.pagination.current = res && res.page ? res.page : state.pagination.current;
                state.pagination.pageSize = res && res.limit ? res.limit : state.pagination.pageSize;

                if (tabKey === this.currentTab) {
                  this.json_data = this.createExportData(mappedUsers);
                }
            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                this.isLoading = false;
            }
        },
        onSearch() {
          const state = this.listState[this.currentTab];
          if (!state) {
            return;
          }
          state.searchTerm = this.userSearchText.trim();
          state.pagination.current = 1;
          this.getUsers(this.currentTab);
        },
        listUpdate(tabKey) {
          const state = this.listState[tabKey];
          if (!state) {
            return;
          }
          this.getUsers(tabKey);
        },
        listFilterCount(tabKey, count){
          const state = this.listState[tabKey];
          if (!state) {
            return;
          }
          state.pagination.pageSize = count;
          state.pagination.current = 1;
          if (tabKey === this.currentTab) {
            this.userSearchText = state.searchTerm || '';
          }
          this.getUsers(tabKey);
        },
        listFilter(tabKey, status){
          const state = this.listState[tabKey];
          if (!state) {
            return;
          }
          state.statusFilter = status;
          state.pagination.current = 1;
          this.getUsers(tabKey);
        },
        handleTableChange(tabKey, { pagination, sorter }) {
          const state = this.listState[tabKey];
          if (!state) {
            return;
          }

          if (pagination) {
            if (pagination.current) {
              state.pagination.current = pagination.current;
            }
            if (pagination.pageSize && pagination.pageSize !== state.pagination.pageSize) {
              state.pagination.pageSize = pagination.pageSize;
            }
          }

          if (sorter) {
            state.sortField = sorter.field;
            state.sortOrder = sorter.order || undefined;
          }

          this.getUsers(tabKey);
        },
        handleTabChange(key) {
          this.currentTab = key;
          const state = this.listState[key];
          if (state) {
            this.userSearchText = state.searchTerm || '';
            if (!state.list.length) {
              this.getUsers(key);
            } else {
              this.json_data = this.createExportData(state.list);
            }
          }
        },
        openNotification(_email) {
          const key = `open${Date.now()}`;
          this.$notification.open({
            message: 'Notification New Agent',
            description:
              `${_email} registered to our Maldive as agent.`,
            btn: h => {
              return h(
                'a-button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  on: {
                    click: () => this.getUsers(this.currentTab),
                  },
                },
                'Update Users',
              );
            },
            key,
            onClose: close,
          });
        },
    }
};
</script>
